/*----------------------------------------
 Content URL replacement */
import constants from 'lib/constants';
import framework from 'framework';

function mapUrl(url) {

	if(framework.global.location.pathname.indexOf('content') === -1) {
		url = url.replace(constants.slingMap, '');
	}
	return url;
}

var returnVal = {
	mapUrl: mapUrl
};

export default returnVal;
